/**
 * Finds the closest scrollable parent
 */
export function getScrollParent(node: any): HTMLElement {
  if (!node) {
    return null
  }

  if (node.scrollHeight > node.clientHeight) {
    return node
  } else {
    return getScrollParent(node.parentNode)
  }
}
